"use client";

import React from "react";
import { Send, CircleCheck } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
function ContactFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center p-12 text-center bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl shadow-xl">
        <CircleCheck className="size-16 text-green-400 mb-4" />
        <h4 className="text-2xl font-default font-semibold text-white mb-2">
          {successMessage}
        </h4>
        <p className="text-white/70 mb-6">
          Մենք կկապվենք ձեզ հետ հնարավորինս շուտ:
        </p>
        <Button onClick={resetForm} variant="outline" className="bg-transparent border-white/20 text-white hover:bg-white/10 hover:text-white">
          Ուղարկել նոր հարցում
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="firstName" rules={{
        required: "Անունը պարտադիր է"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-white/90">Անուն</FormLabel>
              <FormControl>
                <Input placeholder="Ձեր անունը" className="bg-white/5 border-white/10 text-white placeholder:text-white/40 focus-visible:ring-white/20 focus-visible:border-white/30" {...field} />
              </FormControl>
              <FormMessage className="text-red-400" />
            </FormItem>} />

        <FormField control={control} name="lastName" rules={{
        required: "Ազգանունը պարտադիր է"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-white/90">Ազգանուն</FormLabel>
              <FormControl>
                <Input placeholder="Ձեր ազգանունը" className="bg-white/5 border-white/10 text-white placeholder:text-white/40 focus-visible:ring-white/20 focus-visible:border-white/30" {...field} />
              </FormControl>
              <FormMessage className="text-red-400" />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Էլ. փոստը պարտադիր է",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Անվավեր էլ. փոստի հասցե"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-white/90">Էլ. փոստ</FormLabel>
              <FormControl>
                <Input type="email" placeholder="orinak@mail.com" className="bg-white/5 border-white/10 text-white placeholder:text-white/40 focus-visible:ring-white/20 focus-visible:border-white/30" {...field} />
              </FormControl>
              <FormMessage className="text-red-400" />
            </FormItem>} />

        <FormField control={control} name="phone" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-white/90">Հեռախոսահամար</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+374 00 000000" className="bg-white/5 border-white/10 text-white placeholder:text-white/40 focus-visible:ring-white/20 focus-visible:border-white/30" {...field} />
              </FormControl>
              <FormMessage className="text-red-400" />
            </FormItem>} />

        <FormField control={control} name="company" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-white/90">Ընկերություն</FormLabel>
              <FormControl>
                <Input placeholder="Ընկերության անվանումը" className="bg-white/5 border-white/10 text-white placeholder:text-white/40 focus-visible:ring-white/20 focus-visible:border-white/30" {...field} />
              </FormControl>
              <FormMessage className="text-red-400" />
            </FormItem>} />

        <FormField control={control} name="activity" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-white/90">Գործունեության ոլորտ</FormLabel>
              <FormControl>
                <Input placeholder="Օրինակ՝ Գյուղատնտեսություն" className="bg-white/5 border-white/10 text-white placeholder:text-white/40 focus-visible:ring-white/20 focus-visible:border-white/30" {...field} />
              </FormControl>
              <FormMessage className="text-red-400" />
            </FormItem>} />
      </div>

      <FormField control={control} name="message" rules={{
      required: "Հաղորդագրությունը պարտադիր է"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-white/90">Հաղորդագրություն</FormLabel>
            <FormControl>
              <Textarea placeholder="Գրեք ձեր հարցումը այստեղ..." className="min-h-[120px] bg-white/5 border-white/10 text-white placeholder:text-white/40 focus-visible:ring-white/20 focus-visible:border-white/30 resize-y" {...field} />
            </FormControl>
            <FormMessage className="text-red-400" />
          </FormItem>} />

      {submitError && <div className="p-4 bg-red-500/10 border border-red-500/20 rounded-lg">
          <p className="text-red-400 text-sm">{submitError}</p>
        </div>}

      <div className="pt-2">
        <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto px-8 py-6 bg-green-600 hover:bg-green-500 text-white rounded-md font-medium tracking-wide transition-colors shadow-lg shadow-green-900/20">
          {isSubmitting ? <span className="flex items-center gap-2">
              <span className="size-4 border-2 border-white/30 border-t-white rounded-lg animate-spin" />
              Ուղարկվում է...
            </span> : <span className="flex items-center gap-2">
              Հաստատել
              <Send className="size-4" />
            </span>}
        </Button>
      </div>
    </Form>;
}
export default function ContactRequest() {
  return <section id="contactrequest" className="bg-background">
      <div className="w-full bg-[#1e222d] py-20 md:py-32 relative overflow-hidden">
        {}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
          <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-lg bg-green-500/5 blur-[120px]" />
          <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-blue-500/5 blur-[120px]" />
        </div>

        <div className="container mx-auto px-4 md:px-6 relative z-10">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h3 className="text-3xl md:text-4xl font-default font-bold text-white mb-4 tracking-tight">
                Փորձնական լուսանկարների հարցում
              </h3>
              <p className="text-lg text-white/70 max-w-2xl mx-auto">
                Խնդրում ենք լրացնել ձևաթուղթը
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 md:p-10 shadow-2xl">
              <FormProvider formId="contact_form_about_us" sectionName="ContactRequest" defaultValues={{
              firstName: "",
              lastName: "",
              email: "",
              phone: "",
              company: "",
              activity: "",
              message: ""
            }} successMessage="Ձեր հաղորդումը ստացված է">
                <ContactFormInner />
              </FormProvider>
            </div>
          </div>
        </div>
      </div>
    </section>;
}